import { ArrowRightLeft } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { STORAGE_PREFIX } from "@config";
import { canAccessV2 } from "./v2Access";

export default function V2Switch({
  showLabel = true,
  navItemPad = "p-3",
  navItemText = "text-sm",
  iconSize = 20,
  onNavigate,
}) {
  const { t } = useTranslation();
  const location = useLocation();
  const clubId = window.localStorage.getItem(`${STORAGE_PREFIX}club_id`);

  if (!canAccessV2(clubId)) return null;

  const isV2 = location.pathname.startsWith("/v2");
  const target = isV2 ? "/" : "/v2/overview";
  const label = isV2 ? t("v2.shell.legacy_interface") : t("v2.shell.new_interface");

  return (
    <Link
      to={target}
      aria-label={label}
      title={label}
      onClick={onNavigate}
      className={`flex items-center ${navItemPad} ${navItemText} font-medium rounded-lg transition-colors ${
        isV2
          ? "bg-blue-600/20 text-blue-100"
          : "bg-indigo-600/10 text-indigo-100 hover:bg-indigo-600/25"
      }`}
    >
      <ArrowRightLeft size={iconSize} style={{ minWidth: `${iconSize}px` }} />
      {showLabel && <span className="ml-3 whitespace-nowrap">{label}</span>}
    </Link>
  );
}

